import { request } from "./client";

export const apiLogin = (email, password) =>
  request("/auth/login", { method: "POST", body: { email, password } });

export const apiRegister = (name, email, password, phone) =>
  request("/auth/register", {
    method: "POST",
    body: { name, email, password, phone },
  });

export const apiGetMe = () => request("/auth/me");

export const apiChangePassword = (currentPassword, newPassword) =>
  request("/auth/change-password", {
    method: "PUT",
    body: { currentPassword, newPassword },
  });

export const apiForgotPassword = (email) =>
  request("/auth/forgot-password", { method: "POST", body: { email } });

export const apiResetPassword = (token, password) =>
  request(`/auth/reset-password/${token}`, {
    method: "POST",
    body: { password },
  });

export const apiVerifyEmail = (token) => request(`/auth/verify-email/${token}`);

export const apiResendVerification = (email) =>
  request("/auth/resend-verification", { method: "POST", body: { email } });

export const apiLogout = () => request("/auth/logout", { method: "POST" });
export const apiVerifyTwoFactor = (challengeId, code) =>
  request("/auth/2fa/verify-login", {
    method: "POST",
    body: { challengeId, code },
  });
export const apiRequestTwoFactor = (action) =>
  request("/auth/2fa/challenge", { method: "POST", body: { action } });
export const apiConfigureTwoFactor = (action, challengeId, code) =>
  request("/auth/2fa/configure", {
    method: "POST",
    body: { action, challengeId, code },
  });
